import { render, staticRenderFns } from "./NewApiKeys.vue?vue&type=template&id=c8cf0b46&"
import script from "./NewApiKeys.vue?vue&type=script&lang=js&"
export * from "./NewApiKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports